import React from 'react';

const HistoryPage = () => {
  return (
    <div>
      <h3>Start Listening to add podcasts to your history</h3>
    </div>
  );
};

export default HistoryPage;
